const o = {
  name: "Opposite",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M40 0V40H19V39.9746C8.42196 39.4532 0 30.707 0 20C0 9.29303 8.42194 0.545779 19 0.0244141V0H40ZM21 38H38V2H21V38ZM19 2.02734C9.52703 2.5466 2 10.3978 2 20C2 29.6021 9.52705 37.4524 19 37.9717V2.02734Z" fill="currentColor"/>
    </g>
  `
};
export {
  o as Opposite
};
